<template>
  <div>
    <div>
      <v-container>
        <notify-menu></notify-menu>
        <v-layout>
          <v-flex>
            <div>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">Start date</div>
                        <DatePickerWithoutButton
                          @change="onChangeDate"
                          v-model="selectedDate.start"
                        >
                          <input readonly :value="dateFormat(selectedDate.start)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="pl-2">
                      <div class="form-control" style="position: relative">
                        <div class="labelinputontop">End date</div>
                        <DatePickerWithoutButton @change="onChangeDate" v-model="selectedDate.end">
                          <input readonly :value="dateFormat(selectedDate.end)" type="text" />
                        </DatePickerWithoutButton>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div class="text-xs-right">
                        <!-- <exportxlsx></exportxlsx> -->
                        <TicketEdit
                          :type="'add'"
                          @addTicket="onAddTicket"
                          :loading="loading"
                        ></TicketEdit>
                        <v-btn
                          @click="ticket2getticket(limit, offset)"
                          ripple
                          color="primary"
                          outline
                        >
                          <em class="fa fa-refresh" />
                          <span class="pl-2">Refresh</span>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
            <div>
              <v-layout row wrap class="mb-0 pl-2">
                <v-flex xs6>
                  <div>
                    <div class="form-control">
                      <div style="position: relative">
                        <input
                          @keyup.enter="onSearch"
                          class="mb-0"
                          placeholder="Search"
                          v-model="filter.search"
                          type="text"
                        />
                        <v-btn
                          @click="onSearch"
                          :loading="loading"
                          style="position: absolute; right: 5px; top: 5px"
                          class="ma-0"
                          icon
                          ><v-icon color="primary">search</v-icon></v-btn
                        >
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs6 class="pt-0">
                  <div class="text-xs-right">
                    <v-pagination
                      @input="changepage"
                      v-model="page"
                      :length="pagelength"
                      :total-visible="7"
                    ></v-pagination>
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-layout row wrap class="mb-0">
              <v-flex xs3 class="pa-2 mt-0">
                <div class="pa-2" style="background-color: #eee; border-radius: 8px">
                  <div>
                    <div>
                      Sort by
                      <DropdownMenu
                        :outtericon="true"
                        v-model="filter.sortBy"
                        :options="optionsSort"
                        :textValue="'value'"
                        :textLabel="'label'"
                        @change="onSearch"
                      >
                        <span style="font-weight: bold">{{ sortByLabel }}</span>
                      </DropdownMenu>
                    </div>
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div>Priority</div>
                  <div>
                    <multiselect
                      v-model="filter.priority"
                      tag-placeholder="Add this as new tag"
                      placeholder="Priority"
                      @input="onSearch"
                      :searchable="false"
                      :options="optionsPriority"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                    ></multiselect>
                  </div>

                  <div class="mt-3">Status</div>
                  <div>
                    <multiselect
                      v-model="filter.status"
                      @input="onSearch"
                      tag-placeholder="Add this as new tag"
                      placeholder="Status"
                      :searchable="false"
                      :options="optionsStatus"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                    ></multiselect>
                  </div>
                  <div class="mt-3">Tags</div>
                  <div>
                    <multiselect
                      v-model="filter.tags"
                      @input="onSearch"
                      tag-placeholder="Add this as new tag"
                      placeholder="Tags"
                      :options="[]"
                      :multiple="true"
                      :taggable="true"
                      :show-labels="false"
                      @tag="addTag"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs9 class="mt-2">
                <div>
                  <div
                    class="my-0 pa-3"
                    style="background-color: #eee; border-radius: 10px; min-height: 400px"
                  >
                    <div v-if="loading">
                      <scale-loader class="mt-5" :loading="true" :color="'grey'"></scale-loader>
                    </div>
                    <div v-else-if="!tickets.length">
                      <div class="text-xs-center pt-5" style="font-size: 25px">
                        <em style="font-size: 50px" class="far fa-folder-open" />
                        <br />
                        ไม่พบข้อมูล
                      </div>
                    </div>
                    <div v-else-if="!$store.state.loadingAgentGroups">
                      <div v-for="(item, k) in tickets" :key="item.id" class="mb-2">
                        <TicketItem @ontransfer="onSearch" :ticket.sync="tickets[k]"></TicketItem>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import TicketItem from './TicketItem.vue'
import notifyMenu from './notifyMenu.vue'
import TicketEdit from './TicketEdit.vue'
import Multiselect from 'vue-multiselect'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

import { mapGetters } from 'vuex'
export default {
  components: {
    DatePickerWithoutButton,
    exportxlsx,
    DropdownMenu,
    TicketItem,
    notifyMenu,
    Multiselect,
    TicketEdit,
    ScaleLoader
  },
  computed: {
    sortByLabel() {
      return this.optionsSort.find((el) => el.value == this.filter.sortBy).label
    },
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      loading: false,
      showAdd: false,
      optionsPriority: ['Low', 'Medium', 'High'],
      optionsTags: [],
      optionsStatus: ['Pending', 'Answered', 'Cancel', 'Closed'],
      optionsSort: [
        { label: 'Due by time', value: 'duedate' },
        { label: 'Created date', value: 'starttime' },
        { label: 'Priority', value: 'priority' },
        { label: 'Status', value: 'status' }
      ],
      input: {
        search: ''
      },
      filter: {
        search: '',
        sortBy: 'duedate',
        priority: '',
        status: ['Pending', 'Answered'],
        tags: []
      },
      tickets: [],
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted() {
    this.ticket2getticket(this.limit, this.offset)
  },
  methods: {
    onChangeDate() {
      this.ticket2getticket(this.limit, this.offset)
    },
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.ticket2getticket(this.limit, this.offset)
      }
    },
    onAddTicket(ticket) {
      this.onSearch()
    },
    showAddDialog() {
      this.showAdd = true
    },
    addTag(newTag) {
      this.optionsTags.push(newTag)
      this.filter.tags.push(newTag)
    },
    onSearch() {
      this.ticket2getticket(this.limit, this.offset)
    },
    ticket2getticket(limit, offset) {
      var vm = this

      var data = {
        pageid: this.selectedBot.pageid,
        startTime: this.selectedDate.start,
        endTime: this.selectedDate.end,
        limit,
        offset
      }
      Object.entries(this.filter).forEach(([key, value]) => {
        if (value && value.length) {
          if (Array.isArray(value)) {
            Object.assign(data, { [key]: value.join(',').toLowerCase() })
          } else {
            if (key == 'channel' && value == 'all') {
            } else {
              Object.assign(data, { [key]: value.toLowerCase() })
            }
          }
        }
      })
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      this.loading = true
      api.ticket2CommonGetTicket(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          this.tickets = response.data
          this.pagetotal = parseInt(response.total)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.labelinputontop {
  position: absolute;
  top: -9px;
  left: 12px;
  font-size: 14px;
  color: #8c8c8c;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/cityfresh/management/Management.vue